import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { bodyLarge, bodyMedium, bodySmall } from '../paragraph';
import { Variant } from '../paragraph/paragraph';
import { ButtonSize } from './counter-input';

export const StyledButton = styled.button<{
  disabled: boolean;
  size: ButtonSize;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: transparent;
  margin: ${({ theme }): string => `0 ${theme.spacing_unit_x1}`};
  ${({ disabled, theme }): { cursor: string; border: string } => {
    if (disabled) {
      return {
        cursor: 'not-allowed',
        border: `2px solid ${theme.palette_gray_60}`
      };
    } else {
      return {
        cursor: 'pointer',
        border: `2px solid ${theme.palette_gray_100}`
      };
    }
  }}
  ${({ size }): { height: string; width: string } => {
    if (size === 'large') {
      return {
        height: '3rem',
        width: '3rem'
      };
    }

    if (size === 'medium') {
      return {
        height: '2rem',
        width: '2rem'
      };
    }

    return {
      height: '1.5rem',
      width: '1.5rem'
    };
  }};
`;

export const ReadOnlyInput = styled.input<{
  variant: Variant;
}>`
  border: none;
  outline: none;
  width: 3rem;
  text-align: center;
  ${({ variant }): FlattenSimpleInterpolation | undefined => {
    if (variant === 'large') {
      return bodyLarge;
    }

    if (variant === 'medium') {
      return bodyMedium;
    }

    if (variant === 'small') {
      return bodySmall;
    }

    return;
  }}
`;

export const CurrencySymbol = styled.div<{ variant: Variant }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${(): string => `-4px`};
  position: relative;

  svg {
    ${({ variant }): { [key: string]: string } => {
      if (variant === 'large') {
        return {
          height: '22px',
          width: '22px'
        };
      }

      if (variant === 'medium') {
        return {
          height: '18px',
          width: '18px'
        };
      }

      if (variant === 'small') {
        return {
          height: '12px',
          width: '12px'
        };
      }

      return {};
    }}
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
